// extracted by mini-css-extract-plugin
module.exports = {"form":"_93444fe79c--form--bKSGu","field--main":"_93444fe79c--field--main--X9EBt","license":"_93444fe79c--license--Ni6Vt","message--succeed":"_93444fe79c--message--succeed--RzvnI"};